module.exports = __webpack_public_path__ + "img/3.538782d8.png";